import styled from "styled-components";
import { colors } from "constants/colors";

export const TermsOfServiceContainer = styled.div`
  width: 100%;
  padding: 10px 8px;
  margin: 0;

  .required {
    margin-top: 8px;
    color: ${colors.red};
    font-size: 16px;
  }

  .termsOfService {
    display: flex;

    .text {
      margin-left: 5px;

      .plainText {
        font-size: 16px;
        height: 30px;
        line-height: 24px;
        color: ${colors.black};
        cursor: pointer;
      }

      .highLight {
        font-size: 16px;
        height: 30px;
        line-height: 24px;
        font-weight: 400;
        color: ${colors.hoverBlue};
        white-space: nowrap;
        cursor: pointer;
        text-decoration: underline;
      }

      .required {
        margin-left: 4px;
      }
    }
  }
`;
